import { useMemo } from 'react';

/**
 * Convert an array of `items` into pages with a maximum of `itemsPerPage` items each.
 */
export default function usePaginate<T>(items: T[], itemsPerPage: number) {
  return useMemo(() => {
    const pages = Math.ceil(items.length / itemsPerPage);
    return Array.from({ length: pages }, (_, i) =>
      items.slice(i * itemsPerPage, (i + 1) * itemsPerPage),
    );
  }, [items, itemsPerPage]);
}
